import React, {useState, useEffect} from 'react';
import { TopBar } from "../../shared/topBar/TopBar";
import { ToastContainer, toast } from "react-toastify";
import { UrlPath } from '../../../config/routeConfig';
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { Stepper, Step, StepLabel, Typography} from '@mui/material';
import PartnershipStep from './SetupSteps/PartnershipStep';
import ClientStatementStep from './SetupSteps/ClientStatementStep';
import PartnerStep from './SetupSteps/PartnerStep';
import PartnershipDetailStep from './SetupSteps/PartnershipDetailStep';


export const PartnershipSetup = () => {
    const Level = [{ BreadCrumb: "Admin >", Routes: `${UrlPath.Admin}` }, 
                   { BreadCrumb: "Partnerships > Partnership Setup", Routes: `${UrlPath.PartnershipSetup}` }];
    useEffect(()=>{
        document.title="Partnership Setup";
    },[]);

    const [activeStep, setActiveStep] = useState(0);
    const [selectedPartnership, setSelectedPartnership] = useState(null);
    const [selectedClientStatement, setSelectedClientStatement] = useState(null);
    const [selectedPartner, setSelectedPartner] = useState(null);

    const steps = [
        { title:"Partnership", description:"(Add/Select Partnership)"  },
        { title:"Client Statement", description:"(Add/Select Client Statement)" },
        { title:"Partner", description:"(Add/Select Partner)" },
        { title:"Partnership Details",description:"(Add/Update Partnership Details)" },
    ];


    const renderStepContent = () => {
        switch (activeStep) {
          case 0: return <PartnershipStep selectedPartnership={selectedPartnership} handleSelectedPartnership={setSelectedPartnership}/>;
          case 1: return <ClientStatementStep selectedClientStatement={selectedClientStatement} handleSelectedClientStatement={setSelectedClientStatement}/>;
          case 2: return <PartnerStep selectedPartner={selectedPartner} handleSelectedPartner={setSelectedPartner}/>;
          case 3: return <PartnershipDetailStep/>
          default: return null;
        }
    };

    const handleNext = () => {
        if(activeStep === 0){
            if(selectedPartnership) {
                setActiveStep(1);
            }
            else toast.error('Please Select a Partnership')
        }
        if(activeStep === 1){
            if(selectedClientStatement) {
                setActiveStep(2);
            }
            else toast.error('Please Select a ClientStatement')
        }
        if(activeStep === 2){
            if(selectedPartner) {
                setActiveStep(3);
            }
            else toast.error('Please Select a Partner')
        }
    }
    const handleBack = () => {
        setActiveStep((prevStep) => prevStep - 1);
    }
    return(
        <>
        <TopBar label={"Partnership Setup"} />
        <div className="mainContentData">
            <BreadCrumbs Levels={Level} />
            <div className="container-fluid p-4 ">
                <div className='row'>
                <Stepper activeStep={activeStep} alternativeLabel>
                    {steps.map((step, index) => (
                    <Step key={index}>
                        <StepLabel>
                        <Typography variant="body1" fontWeight="bold" align="center">
                            {step.title}
                        </Typography>
                        <Typography variant="body2" align="center">
                            {step.description}
                        </Typography>
                        </StepLabel>
                    </Step>
                    ))}
                </Stepper>
                </div>
                <div className='row'>
                    <div style={{ margin: '20px 0' }}>
                        {renderStepContent()}
                    </div>
                </div>
                <div className='row d-flex justify-content-end' style={{ marginRight:'65px', gap:'5px' }}>
                <button className="p-sm-btn" onClick={handleBack} disabled={activeStep === 0} style={{width:'75px'}}>
                Previous
                </button>
                <button className="p-sm-btn" onClick={handleNext}  style={{width:'75px'}}>
                {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                </button>
                </div>
            </div>
        </div>
        <ToastContainer/>
        </>
    );
};